var map = {
	"./continue_playing.png": 10,
	"./start.png": 11,
	"./victory.png": 12,
	"./victory2.png": 13,
	"./welldone.png": 14
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5;


//////////////////
// WEBPACK FOOTER
// ../lib/assets/chloe ^\.\/.*$
// module id = 5
// module chunks = 0